import { useState, useEffect, useCallback } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { downloadReport, fetchReportStats, downloadPdfReport } from './ApiHandler/reportsFunction';
import { fetchAllSessions, fetchSessionHosts } from './ApiHandler/sessionFunctions';
import { fetchMyLabs, fetchExistingLabTypes } from './ApiHandler/labFunctions';
import { fetchStates } from './ApiHandler/schoolFunctions';
import Axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const roleStr  = id => id === 1 ? 'admin' : id === 3 ? 'state_officer' : 'mentor';
const isAdmin  = id => id === 1;
const isMentor = id => id === 2;

const REPORTS = [
    { id:'Lab_Type_Sessions_Report', name:'Lab Type Sessions Report',    cat:'Lab Type Reports', roles:[1,2,3], paramType:'labType', desc:'All sessions for a specific lab type (Atal/SATHEE/AI etc)' },
    { id:'All_Lab_Types_Combined',   name:'All Lab Types — Combined',    cat:'Lab Type Reports', roles:[1,3],   paramType:null,     desc:'All sessions from every lab type in one sheet' },
    { id:'Lab_Types_Multisheet',     name:'All Lab Types — Multi-Sheet', cat:'Lab Type Reports', roles:[1,3],   paramType:null,     desc:'One Excel sheet per lab type with summary' },
    { id:'Mentor_Sessions_Summary',  name:'Mentor-wise Sessions Summary', cat:'Mentor Reports',  roles:[1,2,3], paramType:'mentor', desc:'Total sessions per mentor with date range' },
    { id:'Mentor_Sessions_Detail',   name:'Mentor Sessions Full Detail',  cat:'Mentor Reports',  roles:[1,2,3], paramType:'mentor', desc:'All sessions by a specific mentor' },
    { id:'School_Sessions_Summary',  name:'School-wise Sessions Summary', cat:'School Reports',  roles:[1,2,3], paramType:'school', desc:'Total sessions per school with date range' },
    { id:'School_Sessions_Detail',   name:'School Sessions Full Detail',  cat:'School Reports',  roles:[1,2,3], paramType:'school', desc:'All sessions under a specific school' },
    { id:'List_of_All_Sessions_with_School_Details',         name:'All Sessions with School Details',      cat:'Sessions', roles:[1,2,3], paramType:null },
    { id:'Student_Attendance_Report_for_a_Specific_Session', name:'Student Attendance (Specific Session)', cat:'Sessions', roles:[1,2,3], paramType:'session' },
    { id:'Total_Number_of_Students_Attended_per_Session',    name:'Students Attended per Session',         cat:'Sessions', roles:[1,2,3], paramType:null },
    { id:'Sessions_Conducted_in_a_Specific_or_All_states',   name:'Sessions by State',                     cat:'Sessions', roles:[1,3],   paramType:'state' },
    { id:'Sessions_Conducted_by_a_Specific_Host',            name:'Sessions by Host',                      cat:'Sessions', roles:[1,2,3], paramType:'host' },
    { id:'Students_with_Low_Attendance_Across_All_Sessions', name:'Students with Low Attendance',          cat:'Sessions', roles:[1,2,3], paramType:null },
    { id:'List_of_Schools_with_Total_Sessions_Conducted',    name:'Schools – Total Sessions Conducted',    cat:'Schools',  roles:[1,3],   paramType:null },
    { id:'Schools_with_No_Sessions_Conducted',               name:'Schools with No Sessions',              cat:'Schools',  roles:[1,3],   paramType:null },
    { id:'Schools_Grouped_by_State',                         name:'Schools Grouped by State',              cat:'Schools',  roles:[1,3],   paramType:'state' },
    { id:'Schools_with_Labs_but_No_Equipment_Allocations',   name:'Schools with Labs but No Equipment',    cat:'Schools',  roles:[1,3],   paramType:null },
    { id:'Total_Number_of_Labs_per_School',                  name:'Labs per School',                       cat:'Labs',     roles:[1,3],   paramType:'state' },
    { id:'Labs_Grouped_by_Type',                             name:'Labs by Type',                          cat:'Labs',     roles:[1,3],   paramType:null },
    { id:'Labs_Added_in_past',                               name:'Labs Added in Period',                  cat:'Labs',     roles:[1,3],   paramType:'days' },
    { id:'Total_count_of_equipment_available',                name:'Equipment Available',                  cat:'Equipment',roles:[1],     paramType:null },
    { id:'List_of_Equipment_with_Expired_Warranties',         name:'Equipment – Expired Warranties',       cat:'Equipment',roles:[1],     paramType:null },
    { id:'Recently_Added_Equipment_for_a_period',             name:'Recently Added Equipment',             cat:'Equipment',roles:[1],     paramType:'days' },
    { id:'Equipment_Inventory_Status_Available_vs_Allocated', name:'Equipment Inventory Status',           cat:'Equipment',roles:[1],     paramType:null },
    { id:'Allocations_Made_in_past',                          name:'Equipment Allocations in Period',      cat:'Equipment',roles:[1,3],   paramType:'days' },
    { id:'Fetch_Student_Data_by_Aadhar',                      name:'Student Data by Aadhaar',              cat:'Students', roles:[1,2,3], paramType:'aadhar' },
];

const PDF_REPORTS = [
    { id:'Sessions_With_Images',     name:'Sessions with Photos',  desc:'All sessions with embedded session images — main PDF feature', roles:[1,2,3], color:'#667eea', icon:'bx-image-alt' },
    { id:'All_Sessions_Summary_Pdf', name:'Sessions Overview',     desc:'Summary stats — totals, by month, by state',                   roles:[1,2,3], color:'#3b82f6', icon:'bx-bar-chart-alt-2' },
    { id:'Lab_Type_Sessions_Pdf',    name:'Lab Type Summary',      desc:'Sessions grouped by lab type (Atal/SATHEE/AI etc)',             roles:[1,2,3], color:'#06b6d4', icon:'bx-collection' },
    { id:'Mentor_Sessions_Pdf',      name:'Mentor Sessions',       desc:'Sessions grouped by mentor with totals',                        roles:[1,2,3], color:'#f59e0b', icon:'bx-user-check' },
    { id:'School_Sessions_Pdf',      name:'School Sessions',       desc:'Sessions grouped by school with totals',                        roles:[1,2,3], color:'#10b981', icon:'bxs-school' },
];

const CAT_COLORS = {
    'Lab Type Reports':'#06b6d4','Mentor Reports':'#f59e0b','School Reports':'#10b981',
    'Sessions':'#3b82f6','Schools':'#8b5cf6','Labs':'#667eea','Equipment':'#ef4444','Students':'#ec4899',
};
const CAT_ICONS = {
    'Lab Type Reports':'bx-collection','Mentor Reports':'bx-user-check','School Reports':'bxs-school',
    'Sessions':'bx-calendar-event','Schools':'bx-building','Labs':'bx-dna','Equipment':'bx-wrench','Students':'bxs-graduation',
};

const Sel = ({ label, value, onChange, children, required }) => (
    <div style={{ display:'flex', flexDirection:'column', gap:5 }}>
        <label style={{ fontSize:12, fontWeight:700, color:'#4a5568', textTransform:'uppercase', letterSpacing:.4 }}>
            {label}{required && <span style={{ color:'#ef4444' }}> *</span>}
        </label>
        <select value={value} onChange={e => onChange(e.target.value)}
            style={{ padding:'9px 12px', border:'1.5px solid #d1d5db', borderRadius:9,
                fontSize:13, outline:'none', background:'#fff', color:value?'#111':'#9ca3af' }}>
            {children}
        </select>
    </div>
);

const DateIn = ({ label, value, onChange }) => (
    <div style={{ display:'flex', flexDirection:'column', gap:5 }}>
        <label style={{ fontSize:12, fontWeight:700, color:'#4a5568', textTransform:'uppercase', letterSpacing:.4 }}>{label}</label>
        <input type="date" value={value} onChange={e => onChange(e.target.value)}
            style={{ padding:'9px 12px', border:'1.5px solid #d1d5db', borderRadius:9, fontSize:13, outline:'none', background:'#fff' }} />
    </div>
);

const StatCard = ({ icon, label, value, color }) => (
    <div style={{ background:'#fff', borderRadius:14, padding:'16px 18px',
        boxShadow:'0 2px 12px rgba(0,0,0,.07)', borderLeft:`4px solid ${color}`,
        display:'flex', flexDirection:'column', gap:4 }}>
        <div style={{ display:'flex', alignItems:'center', gap:8 }}>
            <div style={{ width:34, height:34, borderRadius:9, background:color+'18',
                display:'flex', alignItems:'center', justifyContent:'center' }}>
                <i className={`bx ${icon}`} style={{ fontSize:18, color }} />
            </div>
            <span style={{ fontSize:12, color:'#6b7280', fontWeight:600 }}>{label}</span>
        </div>
        <span style={{ fontSize:26, fontWeight:900, color:'#1a202c' }}>{value ?? '—'}</span>
    </div>
);

const MiniTable = ({ title, color, cols, rows }) => (
    <div style={{ background:'#fff', borderRadius:14, overflow:'hidden', boxShadow:'0 2px 10px rgba(0,0,0,.07)' }}>
        <div style={{ background:color, padding:'10px 14px' }}>
            <span style={{ fontSize:13, fontWeight:700, color:'#fff' }}>{title}</span>
        </div>
        <div style={{ overflowX:'auto' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12 }}>
                <thead>
                    <tr style={{ background:color+'15' }}>
                        {cols.map(c => (
                            <th key={c} style={{ padding:'8px 10px', textAlign:'left',
                                fontWeight:700, color:'#374151', borderBottom:`2px solid ${color}22` }}>{c}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {rows.length > 0 ? rows.map((r,i) => (
                        <tr key={i} style={{ background:i%2===0?'#fff':'#fafbff', borderBottom:'1px solid #f3f4f6' }}>
                            {r.map((cell,j) => (
                                <td key={j} style={{ padding:'7px 10px', color:'#374151',
                                    maxWidth:160, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                                    {j > 0 ? <b style={{ color }}>{cell}</b> : cell}
                                </td>
                            ))}
                        </tr>
                    )) : (
                        <tr><td colSpan={cols.length} style={{ padding:'20px', textAlign:'center', color:'#9ca3af' }}>No data</td></tr>
                    )}
                </tbody>
            </table>
        </div>
    </div>
);

const Reports = ({ role }) => {
    const rs = roleStr(role);
    const [tab,       setTab]       = useState('dashboard');
    const [selReport, setSelReport] = useState('');
    const [filters,   setFilters]   = useState({ labTypeId:'', schoolId:'', mentorId:'', state:'', dateFrom:'', dateTo:'', parameter:'' });
    const [sessions,  setSessions]  = useState([]);
    const [hosts,     setHosts]     = useState([]);
    const [labTypes,  setLabTypes]  = useState([]);
    const [states,    setStates]    = useState([]);
    const [mentors,   setMentors]   = useState([]);
    const [schools,   setSchools]   = useState([]);
    const [stats,     setStats]     = useState(null);
    const [statsLoad, setStatsLoad] = useState(false);
    const [dl,        setDl]        = useState(false);
    // FIX: per-button loading — null=none loading, 'id'=that button loading
    const [dlPdfId,   setDlPdfId]   = useState(null);

    const visible    = REPORTS.filter(r => r.roles.includes(role));
    const categories = [...new Set(visible.map(r => r.cat))];
    const current    = REPORTS.find(r => r.id === selReport);
    const setF = (k, v) => setFilters(p => ({ ...p, [k]: v }));

    const loadStats = useCallback(async () => {
        setStatsLoad(true);
        try {
            const f = {};
            if (filters.dateFrom) f.dateFrom = filters.dateFrom;
            if (filters.dateTo)   f.dateTo   = filters.dateTo;
            if (filters.state && isAdmin(role)) f.state = filters.state;
            const d = await fetchReportStats(f);
            if (d) setStats(d);
        } catch (err) { console.warn('Stats not available:', err.message); }
        finally { setStatsLoad(false); }
    }, [filters.dateFrom, filters.dateTo, filters.state, role]);

    useEffect(() => {
        fetchStates(setStates);
        fetchExistingLabTypes(d => setLabTypes(d || []));
    }, []);

    useEffect(() => { if (tab === 'dashboard') loadStats(); }, [tab]); // eslint-disable-line

    useEffect(() => {
        if (!current) return;
        setFilters(p => ({ ...p, labTypeId:'', mentorId:'', schoolId:'', parameter:'' }));
        const pt = current.paramType;
        if (pt === 'session') fetchAllSessions(setSessions);
        if (pt === 'state' || current.cat === 'School Reports' || current.cat === 'Schools') fetchStates(setStates);
        if (pt === 'host') fetchSessionHosts(setHosts);
        if (pt === 'labType') {
            if (isMentor(role)) {
                fetchMyLabs(d => { const lt=d||[]; setLabTypes(lt); if (lt.length>0) setF('labTypeId', String(lt[0].lab_type_id||'')); });
            } else { fetchExistingLabTypes(d => setLabTypes(d||[])); }
        }
        if (pt === 'mentor' && !isMentor(role)) {
            Axios.get(`${API_URL}/users/fetchUsers`, { headers:{ Authorization:localStorage.getItem('token') } })
                .then(r => { if (r.data.status==='success') setMentors((r.data.data||[]).filter(u=>u.role_id===2)); })
                .catch(err => console.error('Fetch mentors:', err));
        }
        if (pt === 'school') {
            Axios.get(`${API_URL}/schools/fetchAllSchools`, { headers:{ Authorization:localStorage.getItem('token') } })
                .then(r => { if (r.data.status==='success') setSchools(r.data.data||r.data.schools||[]); })
                .catch(err => console.error('Fetch schools:', err));
        }
    }, [selReport]); // eslint-disable-line

    const handleDownload = async () => {
        if (!selReport) return;
        setDl(true);
        try { await downloadReport(selReport, { ...filters }); }
        catch (err) { console.error('Download:', err); }
        finally { setDl(false); }
    };

    const tabStyle = active => ({
        padding:'10px 20px', border:'none', borderRadius:10, cursor:'pointer',
        fontWeight:700, fontSize:13, transition:'all .15s',
        background:active?'#667eea':'transparent', color:active?'#fff':'#6b7280',
    });

    return (
        <div style={{ maxWidth:940, margin:'0 auto', paddingBottom:48 }}>
            <ToastContainer />

            {/* HEADER */}
            <div style={{ display:'flex', alignItems:'center', gap:14, marginBottom:22, flexWrap:'wrap' }}>
                <div style={{ width:50, height:50, borderRadius:14, background:'linear-gradient(135deg,#667eea,#764ba2)',
                    display:'flex', alignItems:'center', justifyContent:'center' }}>
                    <i className="bx bx-bar-chart-alt-2" style={{ fontSize:26, color:'#fff' }} />
                </div>
                <div>
                    <h1 style={{ margin:0, fontSize:20, fontWeight:900, color:'#1a202c' }}>Reports & Analytics</h1>
                    <p style={{ margin:0, fontSize:12, color:'#718096' }}>
                        {rs==='admin'?'🔑 Admin — Full Access':rs==='state_officer'?'🗺️ State Officer — Your State Only':'🔬 Mentor — Your Lab Only'}
                        {' · '}{visible.length} reports available
                    </p>
                </div>
                {isMentor(role) && (
                    <div style={{ marginLeft:'auto', background:'#fef3c7', border:'1px solid #f59e0b',
                        borderRadius:10, padding:'6px 12px', fontSize:12, color:'#92400e', fontWeight:600 }}>
                        <i className="bx bx-lock-alt" style={{ marginRight:4 }} />Restricted to your assigned lab
                    </div>
                )}
            </div>

            {/* TABS */}
            <div style={{ background:'#fff', borderRadius:14, padding:6,
                boxShadow:'0 2px 10px rgba(0,0,0,.07)', display:'inline-flex', gap:4, marginBottom:22 }}>
                <button style={tabStyle(tab==='dashboard')} onClick={() => setTab('dashboard')}>
                    <i className="bx bx-stats" style={{ marginRight:5 }} />Dashboard Stats
                </button>
                <button style={tabStyle(tab==='reports')} onClick={() => setTab('reports')}>
                    <i className="bx bx-download" style={{ marginRight:5 }} />Download Reports
                </button>
                <button style={tabStyle(tab==='pdf')} onClick={() => setTab('pdf')}>
                    <i className="bx bx-file-pdf" style={{ marginRight:5 }} />PDF Reports
                </button>
            </div>

            {/* ── DASHBOARD STATS TAB ── */}
            {tab === 'dashboard' && (
                <div>
                    <div style={{ background:'#fff', borderRadius:14, padding:'16px 20px',
                        boxShadow:'0 2px 10px rgba(0,0,0,.07)', marginBottom:18,
                        display:'flex', gap:14, alignItems:'flex-end', flexWrap:'wrap' }}>
                        <DateIn label="From Date" value={filters.dateFrom} onChange={v => setF('dateFrom',v)} />
                        <DateIn label="To Date"   value={filters.dateTo}   onChange={v => setF('dateTo',v)} />
                        {isAdmin(role) && (
                            <Sel label="State" value={filters.state} onChange={v => setF('state',v)}>
                                <option value="">All States</option>
                                {states.map((s,i) => <option key={i} value={s}>{s}</option>)}
                            </Sel>
                        )}
                        <button onClick={loadStats} disabled={statsLoad}
                            style={{ padding:'9px 20px', background:'linear-gradient(135deg,#667eea,#764ba2)',
                                color:'#fff', border:'none', borderRadius:9, fontSize:13, fontWeight:700,
                                cursor:'pointer', alignSelf:'flex-end', opacity:statsLoad?.7:1 }}>
                            {statsLoad?<i className="bx bx-loader-circle bx-spin"/>:<i className="bx bx-filter"/>}
                            {' '}Apply Filter
                        </button>
                    </div>
                    {stats && (
                        <>
                            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(170px,1fr))', gap:14, marginBottom:20 }}>
                                <StatCard icon="bx-calendar-check" label="Total Sessions"  value={stats.totals?.total_sessions}  color="#667eea" />
                                <StatCard icon="bxs-graduation"    label="Total Attendees" value={stats.totals?.total_attendees} color="#10b981" />
                                <StatCard icon="bx-test-tube"      label="Active Labs"     value={stats.byLab?.length}           color="#f59e0b" />
                                <StatCard icon="bx-user-check"     label="Active Mentors"  value={stats.byMentor?.filter(m=>m.total_sessions>0).length} color="#8b5cf6" />
                                <StatCard icon="bxs-school"        label="Schools"         value={stats.bySchool?.filter(s=>s.total_sessions>0).length} color="#3b82f6" />
                            </div>
                            {stats.byMonth?.length > 0 && (
                                <div style={{ background:'#fff', borderRadius:14, padding:'18px 20px',
                                    boxShadow:'0 2px 10px rgba(0,0,0,.07)', marginBottom:18 }}>
                                    <h3 style={{ margin:'0 0 14px', fontSize:14, fontWeight:800, color:'#374151' }}>📈 Sessions per Month</h3>
                                    <div style={{ display:'flex', alignItems:'flex-end', gap:6, height:130, paddingBottom:28, overflowX:'auto' }}>
                                        {(() => {
                                            const mx = Math.max(...stats.byMonth.map(m=>m.total_sessions), 1);
                                            return stats.byMonth.map((m,i) => (
                                                <div key={i} style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:4, minWidth:42, flex:1 }}>
                                                    <span style={{ fontSize:10, color:'#667eea', fontWeight:700 }}>{m.total_sessions}</span>
                                                    <div style={{ width:'100%', maxWidth:36, height:Math.max(6,(m.total_sessions/mx)*90),
                                                        background:'linear-gradient(180deg,#667eea,#764ba2)', borderRadius:'6px 6px 0 0', transition:'height .3s' }} />
                                                    <span style={{ fontSize:9, color:'#9ca3af', writingMode:'vertical-rl', transform:'rotate(180deg)', whiteSpace:'nowrap' }}>{m.month}</span>
                                                </div>
                                            ));
                                        })()}
                                    </div>
                                </div>
                            )}
                            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))', gap:16 }}>
                                <MiniTable title="🔬 Sessions by Lab" color="#667eea" cols={['Lab','Sessions','Attendees']}
                                    rows={(stats.byLab||[]).slice(0,8).map(r=>[r.lab_name,r.total_sessions,r.total_attendees])} />
                                {!isMentor(role) && (
                                    <MiniTable title="👤 Sessions by Mentor" color="#f59e0b" cols={['Mentor','Sessions','Attendees']}
                                        rows={(stats.byMentor||[]).slice(0,8).map(r=>[r.mentor_name,r.total_sessions,r.total_attendees])} />
                                )}
                                <MiniTable title="🏫 Sessions by School" color="#10b981" cols={['School','Sessions','Attendees']}
                                    rows={(stats.bySchool||[]).slice(0,8).map(r=>[r.school_name,r.total_sessions,r.total_attendees])} />
                            </div>
                        </>
                    )}
                    {!stats && !statsLoad && (
                        <div style={{ textAlign:'center', padding:'60px 20px', color:'#9ca3af' }}>
                            <i className="bx bx-bar-chart" style={{ fontSize:48 }} />
                            <p style={{ marginTop:10 }}>Click <b>Apply Filter</b> to load statistics</p>
                        </div>
                    )}
                    {statsLoad && (
                        <div style={{ textAlign:'center', padding:'60px 20px', color:'#667eea' }}>
                            <i className="bx bx-loader-circle bx-spin" style={{ fontSize:40 }} /><p>Loading statistics…</p>
                        </div>
                    )}
                </div>
            )}

            {/* ── DOWNLOAD REPORTS TAB ── */}
            {tab === 'reports' && (
                <div>
                    <div style={{ background:'#fff', borderRadius:16, boxShadow:'0 2px 12px rgba(0,0,0,.08)', overflow:'hidden', marginBottom:18 }}>
                        <div style={{ background:'linear-gradient(135deg,#667eea,#764ba2)', padding:'13px 20px', display:'flex', alignItems:'center', gap:8 }}>
                            <i className="bx bx-list-ul" style={{ fontSize:18, color:'#fff' }} />
                            <span style={{ fontSize:14, fontWeight:700, color:'#fff' }}>Select Report Type</span>
                        </div>
                        <div style={{ padding:'18px 20px' }}>
                            {categories.map(cat => {
                                const catR = visible.filter(r => r.cat===cat);
                                const col  = CAT_COLORS[cat]||'#667eea';
                                return (
                                    <div key={cat} style={{ marginBottom:18 }}>
                                        <div style={{ display:'flex', alignItems:'center', gap:7, marginBottom:10 }}>
                                            <div style={{ width:28, height:28, borderRadius:8, background:col+'18', display:'flex', alignItems:'center', justifyContent:'center' }}>
                                                <i className={`bx ${CAT_ICONS[cat]||'bx-file'}`} style={{ fontSize:15, color:col }} />
                                            </div>
                                            <span style={{ fontSize:11, fontWeight:800, color:'#6b7280', textTransform:'uppercase', letterSpacing:.6 }}>{cat}</span>
                                            <span style={{ background:col+'22', color:col, borderRadius:20, padding:'1px 8px', fontSize:10, fontWeight:700 }}>{catR.length}</span>
                                        </div>
                                        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(240px,1fr))', gap:8 }}>
                                            {catR.map(r => (
                                                <button key={r.id} type="button" onClick={() => setSelReport(r.id)}
                                                    style={{ padding:'10px 13px', border:'1.5px solid',
                                                        borderColor:selReport===r.id?col:'#e5e7eb', borderRadius:11,
                                                        cursor:'pointer', textAlign:'left',
                                                        background:selReport===r.id?col+'0d':'#fafafa', transition:'all .13s' }}>
                                                    <div style={{ fontSize:13, fontWeight:600, lineHeight:1.4, color:selReport===r.id?col:'#374151' }}>{r.name}</div>
                                                    {r.desc && <div style={{ fontSize:11, color:'#9ca3af', marginTop:3 }}>{r.desc}</div>}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    {selReport && current && (
                        <div style={{ background:'#fff', borderRadius:16, boxShadow:'0 2px 12px rgba(0,0,0,.08)', overflow:'hidden' }}>
                            <div style={{ background:`linear-gradient(135deg,${CAT_COLORS[current.cat]||'#667eea'},${CAT_COLORS[current.cat]||'#667eea'}bb)`,
                                padding:'13px 20px', display:'flex', alignItems:'center', gap:8 }}>
                                <i className="bx bx-filter-alt" style={{ fontSize:17, color:'#fff' }} />
                                <span style={{ fontSize:14, fontWeight:700, color:'#fff' }}>{current.name}</span>
                            </div>
                            <div style={{ padding:'18px 20px' }}>
                                <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))', gap:14, marginBottom:20 }}>
                                    {['Lab Type Reports','Mentor Reports','School Reports'].includes(current.cat) && (
                                        <><DateIn label="From Date" value={filters.dateFrom} onChange={v => setF('dateFrom',v)} />
                                          <DateIn label="To Date"   value={filters.dateTo}   onChange={v => setF('dateTo',v)} /></>
                                    )}
                                    {isAdmin(role) && ['Lab Type Reports','Mentor Reports','School Reports'].includes(current.cat) && (
                                        <Sel label="State (Optional)" value={filters.state} onChange={v => setF('state',v)}>
                                            <option value="">All States</option>
                                            {states.map((s,i) => <option key={i} value={s}>{s}</option>)}
                                        </Sel>
                                    )}
                                    {current.paramType==='labType' && (
                                        isMentor(role) ? (
                                            <div>
                                                <label style={{ fontSize:12, fontWeight:700, color:'#4a5568', textTransform:'uppercase', letterSpacing:.4, display:'block', marginBottom:5 }}>Your Lab Type</label>
                                                <div style={{ padding:'9px 12px', background:'#f0f9ff', border:'1.5px solid #06b6d4', borderRadius:9, fontSize:13, color:'#374151' }}>
                                                    <i className="bx bx-lock-alt" style={{ color:'#06b6d4', marginRight:6 }} />
                                                    {labTypes[0]?.lab_type_name||'Loading…'}
                                                    <span style={{ float:'right', fontSize:10, background:'#06b6d4', color:'#fff', borderRadius:20, padding:'1px 7px' }}>Locked</span>
                                                </div>
                                            </div>
                                        ) : (
                                            <Sel label="Select Lab Type" value={filters.labTypeId} onChange={v => setF('labTypeId',v)}>
                                                <option value="">All Lab Types</option>
                                                {labTypes.map(lt => <option key={lt.lab_type_id} value={lt.lab_type_id}>{lt.lab_type_name}</option>)}
                                            </Sel>
                                        )
                                    )}
                                    {current.paramType==='mentor'&&!isMentor(role) && (
                                        <Sel label="Select Mentor (Optional)" value={filters.mentorId} onChange={v => setF('mentorId',v)}>
                                            <option value="">All Mentors</option>
                                            {mentors.map(m => <option key={m.id} value={m.id}>{m.username} ({m.email})</option>)}
                                        </Sel>
                                    )}
                                    {current.paramType==='school' && (
                                        <Sel label="Select School (Optional)" value={filters.schoolId} onChange={v => setF('schoolId',v)}>
                                            <option value="">All Schools</option>
                                            {schools.map(s => <option key={s.id} value={s.id}>{s.school_name} — {s.state}</option>)}
                                        </Sel>
                                    )}
                                    {current.paramType==='session' && (
                                        <Sel label="Select Session" value={filters.parameter} onChange={v => setF('parameter',v)} required>
                                            <option value="">Select session</option>
                                            {sessions.map(s => <option key={s.id} value={s.id}>{s.session_title} — {s.session_date}</option>)}
                                        </Sel>
                                    )}
                                    {current.paramType==='state' && (
                                        <Sel label="Select State" value={filters.parameter} onChange={v => setF('parameter',v)} required>
                                            <option value="">Select state</option>
                                            {selReport==='Sessions_Conducted_in_a_Specific_or_All_states' && <option value="allStates">All States</option>}
                                            {states.map((s,i) => <option key={i} value={s}>{s}</option>)}
                                        </Sel>
                                    )}
                                    {current.paramType==='host' && (
                                        <Sel label="Select Host" value={filters.parameter} onChange={v => setF('parameter',v)} required>
                                            <option value="">Select host</option>
                                            {hosts.map((h,i) => <option key={i} value={typeof h==='string'?h:h.session_host}>{typeof h==='string'?h:h.session_host}</option>)}
                                        </Sel>
                                    )}
                                    {current.paramType==='days' && (
                                        <Sel label="Select Period" value={filters.parameter} onChange={v => setF('parameter',v)} required>
                                            <option value="">Select period</option>
                                            <option value="7">Last 7 days</option><option value="30">Last 30 days</option>
                                            <option value="90">Last 90 days</option><option value="180">Last 6 months</option>
                                            <option value="365">Last 1 year</option>
                                        </Sel>
                                    )}
                                    {current.paramType==='aadhar' && (
                                        <div>
                                            <label style={{ fontSize:12, fontWeight:700, color:'#4a5568', textTransform:'uppercase', letterSpacing:.4, display:'block', marginBottom:5 }}>Aadhaar Number *</label>
                                            <input type="text" maxLength={12} value={filters.parameter}
                                                onChange={e => setF('parameter', e.target.value.replace(/\D/g,''))}
                                                placeholder="12-digit Aadhaar"
                                                style={{ padding:'9px 12px', border:'1.5px solid #d1d5db', borderRadius:9, fontSize:13, outline:'none', background:'#fff', width:'100%', boxSizing:'border-box' }} />
                                        </div>
                                    )}
                                </div>
                                <button type="button" onClick={handleDownload} disabled={dl}
                                    style={{ display:'flex', alignItems:'center', gap:8, padding:'13px 28px',
                                        background:`linear-gradient(135deg,${CAT_COLORS[current.cat]||'#667eea'},${CAT_COLORS[current.cat]||'#764ba2'})`,
                                        color:'#fff', border:'none', borderRadius:12, fontSize:15, fontWeight:700,
                                        cursor:dl?'not-allowed':'pointer',
                                        boxShadow:`0 4px 14px ${CAT_COLORS[current.cat]||'#667eea'}44`,
                                        opacity:dl?.7:1, transition:'all .2s' }}
                                    onMouseEnter={e => { if(!dl) e.currentTarget.style.transform='translateY(-2px)'; }}
                                    onMouseLeave={e => { e.currentTarget.style.transform='none'; }}>
                                    {dl ? <><i className="bx bx-loader-circle bx-spin"/> Generating Excel…</> : <><i className="bx bx-download"/> Download Excel Report</>}
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            )}

            {/* ── PDF REPORTS TAB ── */}
            {tab === 'pdf' && (
                <div>
                    <div style={{ background:'linear-gradient(135deg,#667eea15,#06b6d415)',
                        border:'1px solid #667eea33', borderRadius:14, padding:'14px 18px',
                        marginBottom:18, display:'flex', alignItems:'center', gap:12 }}>
                        <i className="bx bx-info-circle" style={{ fontSize:22, color:'#667eea' }} />
                        <div>
                            <p style={{ margin:0, fontSize:13, fontWeight:700, color:'#374151' }}>PDF Reports include session images</p>
                            <p style={{ margin:0, fontSize:12, color:'#718096' }}>Photos uploaded during session creation are embedded directly in the PDF. Landscape A4 format with SLATE branding.</p>
                        </div>
                    </div>

                    <div style={{ background:'#fff', borderRadius:14, padding:'16px 20px',
                        boxShadow:'0 2px 10px rgba(0,0,0,.07)', marginBottom:18,
                        display:'flex', gap:14, alignItems:'flex-end', flexWrap:'wrap' }}>
                        <DateIn label="From Date" value={filters.dateFrom} onChange={v => setF('dateFrom',v)} />
                        <DateIn label="To Date"   value={filters.dateTo}   onChange={v => setF('dateTo',v)} />
                        {isAdmin(role) && (
                            <Sel label="State (Optional)" value={filters.state} onChange={v => setF('state',v)}>
                                <option value="">All States</option>
                                {states.map((s,i) => <option key={i} value={s}>{s}</option>)}
                            </Sel>
                        )}
                        <Sel label="Lab Type (Optional)" value={filters.labTypeId} onChange={v => setF('labTypeId',v)}>
                            <option value="">All Lab Types</option>
                            {labTypes.map(lt => (
                                <option key={lt.lab_type_id} value={lt.lab_type_id}>{lt.lab_type_name}</option>
                            ))}
                        </Sel>
                    </div>

                    <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(280px,1fr))', gap:16 }}>
                        {PDF_REPORTS.filter(r => r.roles.includes(role)).map(r => (
                            <div key={r.id} style={{ background:'#fff', borderRadius:16,
                                boxShadow:'0 2px 12px rgba(0,0,0,.08)', overflow:'hidden', border:`1px solid ${r.color}22` }}>
                                <div style={{ background:`linear-gradient(135deg,${r.color},${r.color}bb)`,
                                    padding:'14px 16px', display:'flex', alignItems:'center', gap:10 }}>
                                    <div style={{ width:36, height:36, borderRadius:10, background:'rgba(255,255,255,.2)',
                                        display:'flex', alignItems:'center', justifyContent:'center' }}>
                                        <i className={`bx ${r.icon}`} style={{ fontSize:20, color:'#fff' }} />
                                    </div>
                                    <div>
                                        <p style={{ margin:0, fontSize:13, fontWeight:700, color:'#fff' }}>{r.name}</p>
                                        <p style={{ margin:0, fontSize:11, color:'rgba(255,255,255,.75)' }}>{r.desc}</p>
                                    </div>
                                </div>
                                <div style={{ padding:'14px 16px' }}>
                                    <button
                                        onClick={async () => {
                                            if (dlPdfId) return;        // block if any PDF generating
                                            setDlPdfId(r.id);           // mark THIS button loading
                                            try {
                                                await downloadPdfReport(r.id, {
                                                    dateFrom:  filters.dateFrom  || undefined,
                                                    dateTo:    filters.dateTo    || undefined,
                                                    state:     filters.state     || undefined,
                                                    labTypeId: filters.labTypeId || undefined,
                                                });
                                            } catch(e) { console.error('PDF error:', e); }
                                            finally { setDlPdfId(null); } // always reset
                                        }}
                                        disabled={dlPdfId === r.id}     // only THIS button disabled
                                        style={{ width:'100%', padding:'11px',
                                            background:`linear-gradient(135deg,${r.color},${r.color}bb)`,
                                            color:'#fff', border:'none', borderRadius:10, fontSize:13, fontWeight:700,
                                            cursor: dlPdfId===r.id ? 'not-allowed' : 'pointer',
                                            display:'flex', alignItems:'center', justifyContent:'center', gap:8,
                                            opacity: dlPdfId===r.id ? 0.7 : 1, transition:'all .2s' }}>
                                        {dlPdfId === r.id
                                            ? <><i className="bx bx-loader-circle bx-spin"/> Generating PDF…</>
                                            : <><i className="bx bx-download"/> Download PDF</>
                                        }
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Reports;